import React, { Component } from "react";
import GhostRowInput from "./GhostRowInput";
import RowInput from "./RowInput";
import ToolBox from "./ToolBox";

class RowContent extends Component {
    state = {
        rowStyle: {},
        toolBoxShow: false,

    };
    onDragStart = (e, rowId, sectionId, pageId, inputId, type) => {
        // e.preventDefault()
        e.dataTransfer.setDragImage(this.GhostRowInputRef, 0, 0)
        this.props.showhandlersFunc();
        let dataObject = { rowId, sectionId, pageId, type, inputId, dropType: "CHANGE" };
        if (e.dataTransfer.setData) {
            e.dataTransfer.setData("dragData", JSON.stringify(dataObject));
        } else {
            e.dataTransfer.rowId = rowId;
            e.dataTransfer.sectionId = sectionId;
            e.dataTransfer.pageId = pageId;

            e.dataTransfer.type = type;
            e.dataTransfer.inputId = inputId;
            e.dataTransfer.dropType = "CHANGE";
        }
    };
    onMouseEnter = (e) => {
        e.preventDefault();
        this.setState({ toolBoxShow: true });
        let rowStyle = this.rowRef.style;
        // rowStyle.border = "1px solid #6D79CC15";
        // rowStyle.backgroundColor = "#6D79CC10";

        rowStyle.cursor = "grab";
    };
    onMouseLeave = () => {
        this.setState({ toolBoxShow: false });
        let rowStyle = this.rowRef.style;
        // rowStyle.border = "1px solid transparent";
    };

    openInputConfig = () => {


        this.props.openInputConfig(this.props.header)

    }


    onMouseDown = (e) => {
        // e.persist()
        this.downTime = new Date().getTime()
        // this.setState({showGhost : false}, () => {
        //     let ghostElement = this.GhostRowInputRef;
        //     console.log('e.target', e);
        //     // this.GhostRowInputRef.style.top = 10;
        //     // this.GhostRowInputRef.style.left = 0;
        //     this.rowRef.addEventListener('mousemove', this.onMouseMove, false);

        // })

    }
    onMouseMove = (e) => {
        // e.preventDefault()
        console.log(this.state);
        // this.GhostRowInputRef.style.top = this.state.prevClientY - e.clientY + "px";
        // this.GhostRowInputRef.style.left = this.state.prevClientX - e.clientX  + "px";
    }

    onMouseUp = (e) => {
        let now = new Date().getTime()
        let diff = now - this.downTime

        if (this.props.header && diff < 150) {
            this.openInputConfig()
        }
    }


    deletInputFunction = (inputId, rowId, sectionId, pageId, rowLength) => {
        this.props.deleteInput(inputId, rowId, sectionId, pageId)
        if (rowLength == 0) {
            this.props.setDisplayHandlers()

        }
    }





    render() {
        const dropHandles = [
            { direction: "left", style: {} },
            { direction: "right", style: {} }
        ];
        const {
            type, rowLength, index, showhandlers, displayHandlers, onDrop, onDragOver, onDragLeave, rowId, sectionId, pageId, inputId, deleteInput
        } = this.props;
        // const { rowStyle } = this.state;
        let header = { ...this.props.header }
        header.information.disabled = false

        return (

            <div
                onMouseDown={e => this.onMouseDown(e)}
                onMouseUp={e => this.onMouseUp(e)}

                onMouseEnter={(e) => this.onMouseEnter(e)}
                onMouseLeave={(e) => this.onMouseLeave(e)}
                ref={(el) => (this.rowRef = el)}
                className={"row-item"}
                onDragStart={(e) =>
                    this.onDragStart(e, rowId, sectionId, pageId, inputId, type)
                }
                onDragEnd={() => this.props.hideHandlersFunc()}
                draggable={true}
            >
                <div className="px-1 w-100 " >
                    <RowInput header={header} inputClass={this.props.inputClass} />
                    <GhostRowInput inputClass={this.props.inputClass} ref={el => this.GhostRowInputRef = el} header={header} />

                    {showhandlers && displayHandlers
                        ? dropHandles.map((handler, indexhandle) => {
                            const { direction, style } = handler;

                            if (index > 0) {
                                return (
                                    <div key={indexhandle} className={"side-handler " + "right"} onDrop={(e) => onDrop(e, rowId, sectionId, pageId, direction, index)} onDragOver={(e) => onDragOver(e, this.innerLine)} onDragLeave={(e) => onDragLeave(e, this.innerLine)}>
                                        <div ref={el => this.innerLine = el} style={{ width: 1, height: 'calc(100% - 6px)', borderLeft: '1px dashed #6D79CC', pointerEvents: 'none' }}>
                                        </div>
                                    </div>
                                );
                            }
                            return (
                                <div className={"side-handler " + direction} onDrop={(e) => onDrop(e, rowId, sectionId, pageId, direction, index)} onDragOver={(e) => onDragOver(e, this.innerLine)} onDragLeave={(e) => onDragLeave(e, this.innerLine)} key={indexhandle}>
                                    <div ref={el => this.innerLine = el} style={{ width: 1, height: 'calc(100% - 6px)', borderLeft: '1px dashed #6D79CC', pointerEvents: 'none' }}>
                                    </div>
                                </div>
                            );
                        })
                        : null}
                </div>
                {this.state.toolBoxShow ? (
                    <ToolBox
                        setFormData={this.props.setFormData}
                        deleteRow={() => this.deletInputFunction(inputId, rowId, sectionId, pageId, rowLength)}
                        openInputConfig={() => this.openInputConfig()}
                    />
                ) : null}
            </div>
        );
    }
}

export default RowContent;
